import { DIRECT_DEBIT } from '@tectonics/prs/nigeria/validation/nigerian-bank-code';

export const NIGERIAN_EWALLET_BRANDS: readonly string[] = ['ussd', DIRECT_DEBIT];

export function filterNigerianEwalletBrands(brands: readonly string[]): readonly string[] {
  return brands.filter(brand => NIGERIAN_EWALLET_BRANDS.includes(brand));
}
